var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container"},[_c('CurrentWeather'),_c('TenHourForecast'),_c('div',{staticClass:"settings"},[_c('DegreeToggle')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }